import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fbde6bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=0fbde6bc&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbde6bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbde6bc')) {
      api.createRecord('0fbde6bc', component.options)
    } else {
      api.reload('0fbde6bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0fbde6bc&scoped=true", function () {
      api.rerender('0fbde6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/Uploader/Avatar/index.vue"
export default component.exports